import { DetailTable } from '../../../mapping-classes/detail-table';

export class RestrictedMandateListings implements DetailTable {
  shieldedText = 'Afgeschermd';
  restrictedData: boolean;
  title: string;
  rowHeaders: string[];
  rowData: any[];
  errorText: string;

  constructor(restrictedMandateListings: any) {
    if (!restrictedMandateListings) {
      this.createErrorMessage();
    } else {
      this.rowHeaders = [];
      this.rowData = [];
      this.setRowHeaders();
      this.setRowData(restrictedMandateListings);
    }
  }

  createErrorMessage() {
    this.errorText = '';
  }

  setRowHeaders() {
    this.rowHeaders = [
      'incassantName',
      'incassantId',
      'machtigingskenmerk',
      'maxAantalKalJaar',
      'maxBedragKeer'
    ];
  }

  setRowData(basicTableData) {
    basicTableData.forEach((details) => {
      this.rowData.push(details);
    });
  }
}
